import { BadgeTranslate } from './badgeTranslate.model';

const badgeTranslatePTBR: BadgeTranslate = {
  chip: {
    remove: 'Remover etiqueta {{name}}',
    archivedTitle: '{{name}} (etiqueta arquivada)',
  },
  combobox: {
    triggerAriaLabel: 'Selecionar etiquetas',
    placeholder: 'Adicionar etiquetas',
    searchPlaceholder: 'Buscar etiqueta',
    loading: 'Carregando...',
    empty: 'Nenhuma etiqueta encontrada',
    createNew: 'Nova etiqueta',
    createNamed: 'Criar "{{name}}"',
    createTitle: 'Nova etiqueta',
    editTitle: 'Editar etiqueta',
    editAriaLabel: 'Editar etiqueta {{name}}',
    manage: 'Gerenciar etiquetas',
    namePlaceholder: 'Nome da etiqueta',
    colorLabel: 'Cor',
    colorTrigger: 'Cor',
    cancel: 'Cancelar',
    confirm: 'Criar',
    save: 'Salvar',
  },
  filter: {
    placeholder: 'Filtrar por etiqueta',
  },
  settings: {
    title: 'Etiquetas',
    description: 'Gerencie as etiquetas usadas para classificar seus leads.',
    newBadge: 'Nova etiqueta',
    empty: 'Nenhuma etiqueta cadastrada',
    usageCount: '{{count}} uso(s)',
    actions: {
      edit: 'Editar',
      delete: 'Excluir',
    },
    form: {
      titleCreate: 'Nova etiqueta',
      titleEdit: 'Editar etiqueta',
      save: 'Salvar',
    },
  },
  modal: {
    delete: {
      title: 'Excluir etiqueta',
      text: 'Tem certeza que deseja excluir a etiqueta "{{name}}"?',
      secondaryText:
        'A etiqueta será removida do catálogo, mas continuará visível nos leads que já a possuem (em modo arquivado).',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
  },
  toast: {
    created: 'Etiqueta criada',
    updated: 'Etiqueta atualizada',
    deleted: 'Etiqueta excluída',
    error: {
      create: 'Erro ao criar etiqueta',
      update: 'Erro ao atualizar etiqueta',
      delete: 'Erro ao excluir etiqueta',
    },
  },
  colors: {
    RED: 'Vermelho',
    PINK: 'Rosa',
    PURPLE: 'Roxo',
    INDIGO: 'Índigo',
    BLUE: 'Azul',
    LIGHT_BLUE: 'Azul claro',
    CYAN: 'Ciano',
    TEAL: 'Verde-azulado',
    GREEN: 'Verde',
    LIME: 'Lima',
    YELLOW: 'Amarelo',
    ORANGE: 'Laranja',
    GRAY: 'Cinza',
    BLACK: 'Preto',
    WHITE: 'Branco',
  },
};

export default badgeTranslatePTBR;
